const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

// (version: Age I's was changed by the expansion, 6 resources instead of 5; see Constants/CardVersions.js)
class WealthyTerritory extends Territory {
    constructor(age, version){
        super(
            age,
            TerritoryNames.WealthyTerritory,
            "Gain " + WealthyTerritory.GetBlueCubeCount(age) + " blue cubes and gain " + WealthyTerritory.GetResourceCount(age, version) + " resources.",
            {}
        )
        this.version = version;
    }

    static GetBlueCubeCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 4;
        }
    }

    static GetResourceCount(age, version)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return version === 'expansion' ? 6 : 5;
            case Age.Age2:
                return 9;
        }
    }
}

module.exports = WealthyTerritory;